// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { GetProductDetailsQuery, BaseResponseListProductDetailFoundResponse } from '../types';

/**
 * findAll
 *
 * @export
 * @tags product-detail-controller
 * @link [GET] /productDetails
 */
export function getProductDetails(): Promise<BaseResponseListProductDetailFoundResponse>;
export function getProductDetails(
    options: ApiOptions<never, GetProductDetailsQuery>
): Promise<BaseResponseListProductDetailFoundResponse>;
export function getProductDetails(
    options?: ApiOptions<never, GetProductDetailsQuery>
): Promise<BaseResponseListProductDetailFoundResponse> {
    return request<never, never, GetProductDetailsQuery>('/productDetails', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getProductDetails',
    });
}

export const meta = [
    { tags: ['product-detail-controller'], path: '/productDetails', method: 'get' },
];
